import { gql } from 'apollo-angular';
import { CBFF, MCF, HCF, LTCF, CBRRF, BH, HEADER_FIELDS } from 'src/app/gql';
import { FCF } from 'src/app/gql/footer-cta';

export const GET_NT_Experiences = gql`
query getNtExperiences($preview: Boolean! = false, $domain: String) {
  ntExperienceCollection(preview: $preview, limit: 20, where: { domain: $domain }) {
    items {
      sys {
        id
      }
      ntName
      ntDescription
      ntType
      ntConfig
      ntExperienceId
      ntAudience {
        sys {
          id
        }
        ntAudienceId
        ntRules
      }
      ntVariantsCollection(limit: 5) {
        items {
          __typename
          ... on ContentBlock { ...CBFF }
          ... on MultiColumn { ...MCF }
          ... on BigHero { ...BH }
          ... on HorizontalCallout { ...HCF }
          ... on Large2Column { ...LTCF }
          ... on ContentBlockWithRightRailCallout { ...CBRRF }
          ... on FooterCta { ...FCF }
          ... on WebsiteHeader { ...HEADER_FIELDS }
        }
      }
    }
  }
}
${CBFF}
${MCF}
${HCF}
${LTCF}
${CBRRF}
${BH}
${FCF}
${HEADER_FIELDS}`;
